var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 0.25C5.90833 1.37459 0.422363 7.58074 0.422363 15.0682C0.422363 18.0867 1.31397 20.897 2.84819 23.25C3.19174 23.7769 3.79136 24.0682 4.42036 24.0682H26.4244C27.0534 24.0682 27.653 23.7769 27.9965 23.25C29.5308 20.897 30.4224 18.0867 30.4224 15.0682C30.4224 7.58506 24.9427 1.38176 17.7771 0.251952L18.1078 2.64733C23.8636 3.88059 28.1789 8.9967 28.1789 15.1207C28.1789 17.5753 27.4857 19.8679 26.2843 21.8135H4.56038C3.35901 19.8679 2.66577 17.5753 2.66577 15.1207C2.66577 8.99362 6.98544 3.87545 12.7455 2.64547L13.08 0.25Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6169 15.5042C18.6169 17.2685 17.1867 18.6987 15.4224 18.6987C13.658 18.6987 12.2278 17.2685 12.2278 15.5042C12.2278 13.7398 15.4224 0.30957 15.4224 0.30957C15.4224 0.30957 18.6169 13.7398 18.6169 15.5042Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureNormal);
export default __webpack_public_path__ + "static/media/pressure_normal.d095fbdb1eb5bf5942c79dd4b65fd544.svg";
export { ForwardRef as ReactComponent };